import styled from 'styled-components'

import { Link } from '../../../common/text-styled'
import { media } from '../../../../constants/media'

export const Container = styled.div`
  width: 100%;
`;

export const Grid = styled.div`
  text-align: left;
  overflow: hidden;
  display: grid;
  grid-template-columns: minmax(1fr, ${media.small.maxWidth});
  grid-template-rows: 275px repeat(4, auto);
  grid-template-areas:
    "photo"
    "ingredients"
    "directions"
    "notes"
    "instagram"
    "nutrition";
  @media ${media.medium.query} {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 500px repeat(3, auto);
    grid-template-areas:
      "photo photo"
      "ingredients directions"
      "notes notes"
      "instagram instagram"
      "nutrition nutrition";
  }
`;

export const PhotoArea = styled.div`
  grid-area: photo;
  overflow: hidden;
  align-self: end;
  @media ${media.medium.query} {
    border-radius: 15px 15px 0 0;
    align-self: normal;
  }
`;

export const IngredientsArea = styled.div`
  grid-area: ingredients;
  background-color: white;
  padding-top: 30px;
  padding-left: 40px;
  padding-right: 20px;
  @media ${media.medium.query} {
    padding-top: 40px;
    padding-left: 55px;
  }
`;

export const DirectionsArea = styled.div`
  grid-area: directions;
  background-color: white;
  padding-top: 30px;
  padding-left: 40px;
  padding-right: 20px;
  padding-bottom: 30px;
  @media ${media.medium.query} {
    padding-top: 40px;
    padding-left: 55px;
  }
`;

export const NotesArea = styled.div`
  grid-area: notes;
  background-color: white;
  padding: 60px 36px;
  @media ${media.medium.query} {
    padding: 40px 54px;
  }
`;

export const InstagramArea = styled.div`
  grid-area: instagram;
  background-color: white;
  text-align: center;

  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 60px;
  @media ${media.medium.query} {
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 40px;
  }
`;

export const SalmonText = styled.div`
  font-family: ${props => props.theme.fonts.solway};
  font-size: 2rem;
  font-weight: bold;
  color: ${props => props.theme.colors.salmon};
`;

export const GrayText = styled.div`
  font-family: ${props => props.theme.fonts.solway};
  font-size: 2rem;
  font-weight: normal;
  color: ${props => props.theme.colors.gray};
`;

export const A = styled(Link)`
`;

export const NutritionArea = styled.div`
  grid-area: nutrition;
  background-color: ${props => props.theme.colors.salmon};
  padding: 25px 36px;
  @media ${media.medium.query} {
    padding: 52px 54px;
    border-radius: 0 0 15px 15px;
  }
  color: white;
`;

export const Title = styled.div`
  font-family: ${props => props.theme.fonts.solway};
  color: ${props => props.theme.colors.salmon};
  font-weight: normal;
  font-size: 3rem;
  line-height: 4.2rem;
  letter-spacing: 0.038rem;
  margin-bottom: 20px;
  @media ${media.medium.query} {
    font-size: 3.3rem;
    margin-bottom: 30px;
  }
`;

export const NutritionTitle = styled(Title)`
  color: white;
`;